export default __webpack_public_path__ + "img/homepage.commitment.03.asset.d1560db6.jpg";